import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  rules: [],
  pagination: {},
  loading: false,
  deleteLoading: false,
  deleteSuccess: false,
  currentRuleset: {
    ruleset: {},
    loading: false,
    isFetching: false,
    errors: undefined,
  },
};

const reservationRulesetsReducer = createReducer(initialState)({
  // GET RESERVATIONS LIST
  [types.FETCH_RESERVATION_RULESETS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_RESERVATION_RULESETS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      rules: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_RESERVATION_RULESETS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  // GET RESERVATIONS LIST
  [types.FETCH_RESERVATION_RULESET_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      currentRuleset: {
        ...state.currentRuleset,
        loading: true,
      },
    };
  },
  [types.FETCH_RESERVATION_RULESET_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      currentRuleset: {
        ...state.currentRuleset,
        ruleset: payload.data,
        loading: false,
      },
    };
  },
  [types.FETCH_RESERVATION_RULESET_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      currentRuleset: {
        ...state.currentRuleset,
        loading: false,
      },
    };
  },
  [types.CREATE_RESERVATION_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      currentRuleset: {
        ...state.currentRuleset,
        isFetching: true,
        fetch,
      },
    };
  },
  [types.CREATE_RESERVATION_RULESET_SUCCESS]: (state) => {
    return {
      ...state,
      currentRuleset: {
        ...state.currentRuleset,
        isFetching: false,
      },
    };
  },
  [types.CREATE_RESERVATION_RULESET_FAILED]: (state) => {
    return {
      ...state,
      currentRuleset: {
        ...state.currentRuleset,
        isFetching: false,
      },
    };
  },
  [types.UPDATE_RESERVATION_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      currentRuleset: {
        ...state.currentRuleset,
        isFetching: true,
        fetch,
      },
    };
  },
  [types.UPDATE_RESERVATION_RULESET_SUCCESS]: (state) => {
    return {
      ...state,
      currentRuleset: {
        ...state.currentRuleset,
        isFetching: false,
      },
    };
  },
  [types.UPDATE_RESERVATION_RULESET_FAILED]: (state, { payload: errors }) => {
    return {
      ...state,
      currentRuleset: {
        ...state.currentRuleset,
        isFetching: false,
        errors,
      },
    };
  },
  [types.DELETE_RESERVATION_RULESET_REQUEST]: (state) => {
    return {
      ...state,
      deleteLoading: true,
    };
  },
  [types.DELETE_RESERVATION_RULESET_SUCCESS]: (state) => {
    return {
      ...state,
      deleteLoading: false,
      deleteSuccess: true,
    };
  },
  [types.DELETE_RESERVATION_RULESET_FAILED]: (state, { payload: errors }) => {
    return {
      ...state,
      deleteLoading: false,
      deleteSuccess: false,
    };
  },
  [types.RESET_CURRENT_RESERVATION_RULESET]: (state) => {
    return {
      ...state,
      deleteLoading: false,
      deleteSuccess: false,
      currentRuleset: {
        ...initialState.currentRuleset,
      },
    };
  },
  // FETCH UPDATE RESERVATION RULESET INFO
  [types.FETCH_UPDATE_RESERVATION_RULESET_INFO_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      currentRuleset: {
        ...state?.currentRuleset,
        ruleset: {
          ...state?.currentRuleset?.ruleset,
          ...payload,
        },
      },
    };
  },
});

export default reservationRulesetsReducer;
